document.addEventListener('DOMContentLoaded', function () {

  /* =========================================
    CHECK LANGUAGE
  ========================================== */

  const lang = (
    window.Shopify && Shopify.locale
      ? Shopify.locale
      : document.documentElement.lang || 'en'
  ).toLowerCase();

  if (!lang.startsWith('ar')) return;


  /* =========================================
    GENERIC RETRY-UNTIL-TRUE POLLER

    Keeps calling `attemptFn` every `interval` ms
    until it returns true (success) or we run out
    of attempts. This is the key fix: translation
    functions now report whether they actually did
    something, and we keep retrying until they do.
  ========================================== */

  function pollUntilTrue(attemptFn, interval = 150, maxAttempts = 40) {
    let attempts = 0;

    function tick() {
      const success = attemptFn();
      attempts++;

      if (success) return;
      if (attempts < maxAttempts) {
        setTimeout(tick, interval);
      }
    }

    tick();
  }


  /* =========================================
    PRODUCT PAGE BUTTON

    Returns true only once the button text has
    actually been changed to Arabic, so the poller
    knows to stop.
  ========================================== */

  function translateProductButton() {
    const button = document.querySelector(
      '#klaviyo-bis-button-container button'
    );

    if (!button) return false;

    if (button.textContent.trim() !== 'أبلغني عند التوفر') {
      button.textContent = 'أبلغني عند التوفر';
    }

    return button.textContent.trim() === 'أبلغني عند التوفر';
  }

  // Initial page load
  pollUntilTrue(translateProductButton, 150, 40); // up to ~6s

  // HEARTBEAT: instead of trying to hook every possible variant
  // picker markup (swatches, dropdowns, radios, etc. all differ
  // by theme), just keep re-checking the button text in the
  // background. This catches ANY re-render Klaviyo does —
  // variant change, stock refresh, AJAX cart, etc. — without
  // needing to know what triggered it.
  //
  // Cost: one querySelector + one string comparison every 400ms.
  // This runs after DOMContentLoaded, so it has zero effect on
  // FCP/LCP; it's negligible for CPU/battery too since it's not
  // doing any layout or paint work.
  setInterval(translateProductButton, 400);


  /* =========================================
    TRANSLATE POPUP

    Returns true only once every expected piece
    has been translated, so the poller can keep
    retrying if Klaviyo hasn't finished injecting
    content yet.
  ========================================== */

  function translatePopup() {
    const popup = document.querySelector('[data-testid="POPUP"]');
    if (!popup) return false;

    popup.setAttribute('dir', 'rtl');
    popup.setAttribute('lang', 'ar');

    let headingDone = false;
    let descriptionDone = false;

    const richTexts = popup.querySelectorAll('.klaviyo-form-richtext');

    richTexts.forEach(function (block) {
      const text = block.textContent.trim();
      const span = block.querySelector('span');

      if (!headingDone && (text.includes('Notify when') || text.includes('Back in Stock'))) {
        if (span) {
          span.innerHTML = 'أبلغني عند<br>توفر المنتج';
          headingDone = true;
        }
      } else if (text.includes('أبلغني عند')) {
        headingDone = true; // already translated
      }

      if (!descriptionDone && text.includes('Email me when this product is back in stock')) {
        if (span) {
          span.textContent = 'سنرسل لكِ بريدًا إلكترونيًا عند توفر هذا المنتج من جديد';
          descriptionDone = true;
        }
      } else if (text.includes('سنرسل لكِ')) {
        descriptionDone = true; // already translated
      }
    });

    const emailInput = popup.querySelector('input[type="email"]');
    let inputDone = false;

    if (emailInput) {
      emailInput.placeholder = 'أدخلي عنوان بريدك الإلكتروني';
      emailInput.setAttribute('dir', 'rtl');
      inputDone = true;
    }

    const emailLabel = popup.querySelector('label');
    if (emailLabel) {
      emailLabel.textContent = 'البريد الإلكتروني';
    }

    const submitButton = popup.querySelector('.klaviyo-form-button');
    let submitDone = false;

    if (submitButton) {
      const currentText = submitButton.textContent.trim();
      if (currentText === 'Notify Me!' || currentText === 'Notify Me') {
        submitButton.textContent = 'أبلغني عند التوفر';
      }
      submitDone = submitButton.textContent.trim() === 'أبلغني عند التوفر';
    }

    const closeButton = popup.querySelector('.klaviyo-close-form');
    if (closeButton) {
      closeButton.setAttribute('aria-label', 'إغلاق');
    }

    // Only report success once the parts that matter are all in place.
    return headingDone && descriptionDone && inputDone && submitDone;
  }


  /* =========================================
    THANK YOU MESSAGE
  ========================================== */

  function translateSuccessMessage() {
    const popup = document.querySelector('[data-testid="POPUP"]');
    if (!popup) return false;

    const richTexts = popup.querySelectorAll('.klaviyo-form-richtext');
    let found = false;

    richTexts.forEach(function (block) {
      const text = block.textContent.trim();

      if (text.includes('Thank you. We will notify you when this product is back in stock.')) {
        const message = block.querySelector('strong') || block.querySelector('span');

        if (message) {
          message.textContent = 'شكرًا لكِ. سنقوم بإبلاغك عندما يتوفر هذا المنتج من جديد.';
        } else {
          block.textContent = 'شكرًا لكِ. سنقوم بإبلاغك عندما يتوفر هذا المنتج من جديد.';
        }

        block.setAttribute('dir', 'rtl');
        found = true;
      }
    });

    return found;
  }


  /* =========================================
    WHEN BACK IN STOCK BUTTON IS CLICKED
  ========================================== */

  document.addEventListener('click', function (event) {
    const bisButton = event.target.closest('#klaviyo-bis-button-container button');
    if (!bisButton) return;

    // Klaviyo opens the popup itself — we just wait for it,
    // then keep retrying translation until it verifiably succeeds.
    pollUntilTrue(translatePopup, 100, 40); // up to ~4s
  });


  /* =========================================
    WHEN KLAVIYO SUBMIT BUTTON IS CLICKED
  ========================================== */

  document.addEventListener('click', function (event) {
    const submitButton = event.target.closest('[data-testid="POPUP"] .klaviyo-form-button');
    if (!submitButton) return;

    pollUntilTrue(translateSuccessMessage, 100, 30); // up to 3s
  });

});